<template>
  <v-bottom-sheet 
    :value="show"
    persistent
    :inset="$vuetify.breakpoint.mdAndUp"
    scrollable
    :style="{'height':height + 'px'}"
  >
    <v-dialog
      v-model="importDialog"
      max-width="800px"
    >
      <v-card style="position: relative;">
        <v-btn small text style="position: absolute; top: 15px; right: 15px;" @click="importDialog = false">Close</v-btn>
        <v-card-text class="pt-4">
          <import-ameritas v-if="provider == 'AMERITAS'" @on-imported="importedData" />
<!--          <import-lafayette-life v-if="provider == 'LAFAYETTE_LIFE'" @on-imported="importedData" />-->
          <import-lafayette-life-pdf v-if="provider == 'LAFAYETTELIFE'" @on-imported="importedData" />
          <import-one-america v-if="provider == 'ONEAMERICA'" @on-imported="importedData" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card color="white">
      <v-card-text class="pa-0">
        <v-container fluid style="position: relative;">
          <v-btn small text style="position: absolute; top: 15px; right: 15px;" @click="close()" :disabled="saving">Close</v-btn>
          <v-row>
            <v-col class="title text-center">Edit Policy</v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col
              md="4"
              lg="3"
            >
              <v-text-field
                v-model="name"
                outlined
                dense
                hide-details
                label="Name"
                :disabled="saving"
              />
            </v-col>
            <v-col
              md="4"
              lg="3"
            >
              <v-select
                v-model="user"
                :items="policyUsers"
                hide-details
                label="Policy Holder"
                dense
                outlined
                clearable
                :disabled="saving"
              ></v-select>
            </v-col>
            <v-col
              md="4"
              lg="3"
            >
              <v-text-field
                v-model="opportunity_value"
                outlined
                dense
                hide-details
                label="Opportunity Value"
                :disabled="saving"
              />
            </v-col>
          </v-row>

          <v-divider class="my-4" />
          <div class="text-center title">Policy Data</div>
          <v-row class="justify-center">
            <v-col
              md="3"
              lg="2"
            >
              <v-select
                v-model="type"
                :items="policyTypes"
                outlined
                dense
                hide-details
                label="Type"
                :disabled="saving"
              />
            </v-col>
            <v-col
              md="3"
              lg="2"
            >
              <v-select
                v-model="annual"
                :items="annualOptions"
                outlined
                dense
                hide-details
                label="Premium Period"
                :disabled="saving"
              />
            </v-col>
            <v-col
              md="3"
              lg="2"
            >
              <v-menu
                ref="policyStartMenu"
                v-model="policyStartMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="policy_start_formatted"
                    label="Policy Start"
                    hide-details
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @blur="policy_start = parseDate(policy_start_formatted)"
                    :disabled="saving"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="policy_start" no-title scrollable @input="policyStartMenu = false" type="month"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              md="3"
              lg="2"
              key="providerName"
            >
              <v-autocomplete
                v-model="provider"
                :items="providerOptions"
                outlined
                dense
                hide-details
                placeholder="Provider"
                clearable
                :disabled="saving"
              ></v-autocomplete>
            </v-col>
            <v-fade-transition>
              <v-col v-if="provider == 'other'" md="3" lg="2" key="otherProviderName">
                <v-text-field
                  v-model="provider_other"
                  outlined
                  dense
                  hide-details
                  placeholder="Provider Name"
                  :disabled="saving"
                />
              </v-col>
            </v-fade-transition>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="8">
              <policy-table v-model="policyData" :disabled="saving" />
            </v-col>
            <v-col cols="8" class="text-right">
              <v-btn x-small color="grey" text @click="importPolicyData" v-if="provider && provider != 'other'" :disabled="saving">Import</v-btn>
              <v-btn x-small color="error" text @click="clearPolicyData" :disabled="saving">Clear</v-btn>
            </v-col>
            <v-col cols="8" class="text-center">
              <div class="mx-auto" style="width: 450px; max-width: 450px;">
                <v-checkbox 
                  v-model="dataVerified" 
                  label="I have verified the policy information above is accurate" 
                  dense
                  hide-details
                />
              </div>
            </v-col>
          </v-row>


          <v-row class="mt-6 justify-center">
            <v-col class="text-center">
              <v-btn large color="primary" @click="savePolicy" :loading="saving" :disabled="!dataVerified">Save</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>

</template>

<script>
import PolicyTable from './PolicyTable'
import ImportAmeritas from './instructions/Ameritas'
// import ImportLafayetteLife from './instructions/LafayetteLife'
import ImportLafayetteLifePdf from './instructions/LafayetteLifePdf'
import ImportOneAmerica from './instructions/OneAmerica'

export default {
  name: 'PolicySheet',
  props: {
    household: {
      type: Object,
      required: true
    }
  },
  components: {
    PolicyTable,
    ImportAmeritas,
    // ImportLafayetteLife,
    ImportLafayetteLifePdf,
    ImportOneAmerica
  },
  data() {
    return {
      forceShow: false,
      tempPolicy: null,
      importDialog: false,

      name:           null,
      user:           null,
      annual:         null,
      type:           null,
      provider:       null,
      provider_other: null,
      user_id:        null,
      policyData:     [],

      policyStartMenu: false,
      policy_start: null,
      policy_start_formatted: null,
      opportunity_value: null,

      dataVerified: false,

      saving: false
    }
  },
  mounted () {
    this.reset()
  },
  watch: {
    show(newVal) {
      if(newVal) this.reset()
    },
    policy_start ( newVal ) {
      this.policy_start_formatted = this.formatDate( newVal )
    },
    policyData: {
      handler() {
        this.dataVerified = false
      },
      deep: true
    }
  },
  computed: {
    show() {
      return this.forceShow || (this.$route.name == 'households-policies' && this.$route.params.policy_action == 'edit' && this.$route.params.policy_id)
    },
    height() {
      if(this.$vuetify.breakpoint.smAndDown) return window.innerHeight
      return window.innerHeight - 40
    },
    policyTypes() {
      return [
        {text: 'Whole Life', value: 'WHOLE'},
        {text: 'Universal Life', value: 'UNIVERSAL'}
      ]
    },
    annualOptions() {
      return [
        {text: 'Monthly', value: false},
        {text: 'Annual', value: true}
      ]
    },
    providerOptions() {
      return [
        {
          text: 'Ameritas',
          value: 'AMERITAS'
        },
        /*{
          text: 'Foresters',
          value: 'FORESTERS'
        },*/
        // {
        //   text: 'Lafayette Life',
        //   value: 'LAFAYETTE_LIFE'
        // },
        {
          text: 'Lafayette Life',
          value: 'LAFAYETTELIFE'
        },
        {
          text: 'One America',
          value: 'ONEAMERICA'
        },
        {
          text: 'Other...',
          value: 'other'
        }
      ]
    },
    policyUsers () {
      let users = [
        {
          text: this.household.user.full_name,
          value: this.household.user_id
        }
      ]
      if(this.household.spouse) {
        users.push({
          text: this.household.spouse.full_name,
          value: this.household.spouse_id
        })
      }
      return users
    },
    policyId() {
      return (this.tempPolicy ? this.tempPolicy.id : this.$route.params.policy_id)
    }
  },
  methods: {
    close () {
      this.tempPolicy = null
      if(this.forceShow) {
        this.forceShow = false
      } else {
        this.$router.push({params:{policy_id: null, policy_action: null}})
      }
    },
    open (policy) {
      this.tempPolicy   = policy
      this.forceShow    = true
    },
    reset () {
      if(!this.forceShow) {
        this.household.policies.forEach(p => {
          if(p.id == this.$route.params.policy_id) this.tempPolicy = p
        })
        if(!this.tempPolicy) return
      }
      this.name                     = this.tempPolicy.name
      this.user                     = this.tempPolicy.user_id
      this.opportunity_value        = this.tempPolicy.pipeline_value
      this.type                     = this.tempPolicy.type
      this.annual                   = (this.tempPolicy.annual == 1 ? true : false)
      this.policy_start             = this.$moment(this.tempPolicy.start_date).format('YYYY-MM')
      this.provider                 = this.tempPolicy.provider
      let found                     = false
      this.providerOptions.forEach(o => {
        if(o.value == this.tempPolicy.provider) found = true
      })
      if(!found) {
        this.provider       = 'other'
        this.provider_other = this.tempPolicy.provider
      }
      this.policyData               = JSON.parse(this.tempPolicy.data)

      this.saving                   = false
    },
    resetData() {
      let data = []
      for(let i = 0; i < 80; i ++) {
        let year = {year: i+1, age: null, cash_value: null, premium: null, death_benefit: null}
        if(i == 0) year['1035_exchange'] = null
        if(i < 7) year['lump_sum'] = null
        data.push(year)
      }
      this.policyData               = data
    },
    savePolicy () {
      this.saving         = true
      let finalPolicyData = []
      for(let i = 0; i < this.policyData.length; i++) {
        let d = this.policyData[i]
        let arr     = JSON.parse(JSON.stringify(d))
        let premium = (d.premium === '' || d.premium === null ? this.recentPremium(i) : d.premium)
        arr.premium = premium
        if(d.cash_value !== '' && d.cash_value !== null && d.death_benefit !== '' && d.death_benefit !== null) {
          finalPolicyData.push(arr)
        } else {
          break
        }
      }
      
      let data = {
        user_id:            this.user,
        name:               this.name,
        annual:             (this.annual ? 1 : 0),
        start_date:         this.policy_start + '-05',
        type:               this.type,
        provider:           (this.provider == 'other' ? this.provider_other : this.provider),
        data:               finalPolicyData,
        pipeline_value:     this.opportunity_value
      }
      this.$http.put('policies/' + this.policyId, data)
        .then(response => {
          this.$emit('on-save', response.data)
          if(response.data.alteredPlans) this.$emit('on-plans-altered')
        })
        .catch(err => {
          if(err.response.status == 401) return
          
          let message = ''
          if(err.response.status == 422) {
            message = ':<br><br>'
            for(let i = 0; i < err.response.data.length; i++) {
              message += '<b>' + err.response.data[i].message + '</b><br>'
            }
          }
          console.log('Policy Error: ', err.response);
          this.$swal.fire({
            title: 'Error', 
            html: 'There was an issue saving the policy' + message, 
            type: 'error'
          });
        })
        .finally(() => {
          this.saving = false;
        })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      let [month, year, year2] = date.split('/')
      if(year2) year = year2
      return `${year}-${month.padStart(2, '0')}`
    },
    clearPolicyData() {
      this.$swal.fire({
        title: 'Reset All Data?',
        html: 'Resetting the data will clear out all values in the table below. Are you sure you want to clear everything?',
        confirmButtonText: 'Clear Everything',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#f05d5e',
        icon: 'warning'
      }).then(result => {
        if(result.value) this.resetData()
      })
    },
    importPolicyData() {
      if(this.provider != 'other') {
        this.importDialog = true
      }
    },
    importedData(data) {
      this.policyData = data
      this.importDialog = false
      
      for(let i = 0; i < Object.keys(data).length; i++) {
        let key = Object.keys(data)[i]
        if(parseInt(key) > 7) break
        if(data[key]['1035_exchange'] || data[key].lump_sum) {
          this.$swal.fire('Please Verify', 'It looks like the policy you imported may have a 1035 exchange or lump sum additions. Please double check the numbers and correct them if they are wrong.', 'warning')
          break
        }
      }
    },
    recentPremium(yindex) {
      if(!yindex || yindex == '0') return ''
      for(let i = (yindex - 1); i >= 0; i--) {
        if(this.policyData[i].premium !== null && this.policyData[i].premium !== '') return this.policyData[i].premium
      }
      return ''
    },
  }
}
</script>

<style lang="scss" scoped>
  .darkButtonPrimary {
    ::v-deep .v-btn__content {
      ::v-deep i {
        color: #FFF !important;
      }
      color: #FFF !important;
    }
  }

  .policyButton {
    padding: unset !important;
    padding-top: 100% !important;
    height: unset !important;
    min-height: unset !important;
    max-height: unset !important;
    position: relative;
    width: 100% !important;
    ::v-deep i {
      font-size: 50px;
      margin-bottom: 5px;
    }
    ::v-deep .v-btn__content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      flex-direction: column;
    }
  }
</style>